@for (button of buttons; track button.label) {
    <button i18n [class.button-selected]="button === highlightedButton" (click)="onClick(button)">
        {{ button.label }}
    </button>
}
